import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
// icons
import PDF from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/Pdf';
// styles
import {
  DocumentLinkStyled,
  UlStyled,
} from './styles';

// links data
export const ITEMS = [
  {
    path: '/assets/pdf/financial-reports/investment-holdings/schedule-a.pdf',
    text: (<>Schedule A (Parts 1&#8211;3) &#8212; Real Estate</>),
  },
  {
    path: '/assets/pdf/financial-reports/investment-holdings/schedule-b.pdf',
    text: (<>Schedule B (Parts 1&#8211;3) &#8212; Mortgage Loans</>),
  },
  {
    path: '/assets/pdf/financial-reports/investment-holdings/schedule-ba.pdf',
    text: (<>Schedule BA (Parts 1&#8211;3) &#8212; Other Long&#45;Term Invested Assets</>),
  },
  {
    path: '/assets/pdf/financial-reports/investment-holdings/schedule-d-1.pdf',
    text: (<>Schedule D (Part 1) &#8212; Long&#45;Term Bonds</>),
  },
  {
    path: '/assets/pdf/financial-reports/investment-holdings/schedule-d-2.pdf',
    text: (<>Schedule D (Part 2) &#8212; Stocks</>),
  },
  {
    path: '/assets/pdf/financial-reports/investment-holdings/schedule-d-3.pdf',
    text: (<>Schedule D (Part 3) &#8212; Long&#45;Term Bonds and Stocks Acquired</>),
  },
  {
    path: '/assets/pdf/financial-reports/investment-holdings/schedule-d-4.pdf',
    text: (<>Schedule D (Part 4) &#8212; Long&#45;Term Bonds and Stocks Sold, Redeemed or Otherwise Disposed Of</>),
  },
  {
    path: '/assets/pdf/financial-reports/investment-holdings/schedule-d-5.pdf',
    text: (<>Schedule D (Part 5) &#8212; Long&#45;Term Bonds and Stocks Acquired and Disposed Of</>),
  },
  {
    path: '/assets/pdf/financial-reports/investment-holdings/schedule-d-6.pdf',
    text: (<>Schedule D (Part 6) &#8212; Shares of Subsidiary, Controlled or Affiliated Companies</>),
  },
  {
    path: '/assets/pdf/financial-reports/investment-holdings/schedule-da-1.pdf',
    text: (<>Schedule DA (Part 1) &#8212; Short&#45;Term Investments</>),
  },
  {
    path: '/assets/pdf/financial-reports/investment-holdings/schedule-db-a.pdf',
    text: (<>Schedule DB (Part A) &#8212; Options, Caps, Floors, Collars, Swaps and Forwards Open</>),
  },
  {
    path: '/assets/pdf/financial-reports/investment-holdings/schedule-db-b.pdf',
    text: (<>Schedule DB (Part B) &#8212; Future Contracts Open</>),
  },
  {
    path: '/assets/pdf/financial-reports/investment-holdings/schedule-db-d.pdf',
    text: (<>Schedule DB (Part D) &#8212; Counterparty Exposure of Derivative Instruments Open</>),
  },
  {
    path: '/assets/pdf/financial-reports/investment-holdings/schedule-db-e.pdf',
    text: (<>Schedule DB (Part E) &#8212; Derivatives Hedging Variable Annuity Guarantees</>),
  },
  {
    path: '/assets/pdf/financial-reports/investment-holdings/schedule-dl.pdf',
    text: (<>Schedule DL (Parts 1 &#38; 2) &#8212; Reinvested Collateral Assets</>),
  },
  {
    path: '/assets/pdf/financial-reports/investment-holdings/schedule-e.pdf',
    text: (<>Schedule E (Parts 1&#8211;3) &#8212; Cash</>),
  },
];

export default () => {
  return (
    <SectionContainer
      id='financial-information-investment-holdings'
      backgroundVariant='lightA'
      themeType='lightTheme'>
      <Row align='center'>
        <Col medium={8}>
          <Typography
            component='h2'
            align='center'
            nextElement='typography'>
            Detailed listing of Northwestern Mutual Life Insurance Company&#39;s investment holdings
          </Typography>
          <Typography
            align='center'
            nextElement='typography'>
            (As of <time dateTime='2023-12-31'>December 31, 2024</time>)
          </Typography>
          <UlStyled>
            {(
              ITEMS.map((item, index) => (
                <li key={`list-item-${index + 1}`}>
                  <DocumentLinkStyled
                    linkId={`investment-holdings-document-link-${index + 1}`}
                    linkUrl={item.path}
                    iconObject={PDF}
                    isOutgoingLink>
                    {item.text}
                  </DocumentLinkStyled>
                </li>
              ),
              )
            )}
          </UlStyled>
        </Col>
      </Row>
    </SectionContainer>
  );
};
